module.exports = __webpack_public_path__ + "img/instagram-brands.998ea7bd.svg";